/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 校验忘记密码验证码是否正确
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  retrievePasswordDto: member.RetrievePasswordDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/retrieving-password/checking-captcha`,
    data: retrievePasswordDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
